<template>
  <div>
    <div class="el-div">
    </div>
    <div style="width: 90%;height: 90%;margin-left: 5%">
      <el-row gutter="25">
        <img
            @click="initCardInfo()"
            class="lesson-img"
            src="@assets/images/gaode_back.jpg"
            alt="加载失败"
        />
      </el-row>
      <el-row gutter="25">
        <el-table size="mini"
                  :data="userCard"
                  max-height="500"
                  style="width: 100%">
          <el-table-column
              label="日期">
            <template slot-scope="scope">
            <span>{{
                scope.row.useDate | formatDate
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="gaodeCard" label="券码">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  type="success"
                  @click="copy(scope.row.gaodeCard)"
              >复制
              </el-button>
            </template>
          </el-table-column>
        </el-table>

      </el-row>
    </div>
  </div>
</template>

<script>
import {getUserCard} from "@api/store";
import {formatDate} from "@api/date";


export default {
  name: "ECardDetail",
  data() {
    return {
      userCard: []
    }
  },
  methods: {
    initCardInfo: function () {
      {
        getUserCard().then(res => {
          this.userCard = res;
          console.debug(this.userCard);
        });
      }
    },
    copy(data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象
      document.execCommand("Copy") // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      })
      oInput.remove()
    }
  },
  mounted() {
    this.initCardInfo();
  },
  filters: {
    //时间戳
    formatDate(time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd')
    },
    formatDateDay(time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd')
    },
    formatStr(str) {
      var strArray = str.split('.')
      return strArray[0]
    },
  },
}
</script>

<style>
.el-div {
  width: 100% !important;
  height: 8vh !important;
  text-align: center !important;
  background-size: 100% 100% !important; /*按比例缩放*/
  background-image: url("../../assets/images/classChannel/xxpd-tou.jpg");
}
</style>
